export default __webpack_public_path__ + "static/media/TheRecharge_Neoncar00296.c2738492.png";